<template>
    <div>
        <h1 class="title header">{{ $t('FAQ_HEADER_TITLE') }}</h1>
        <div class="all-content">
            <div class="img-cls">
                <img src="@/assets/img/video.jpg" alt="video" width="165" align="center"/>
            </div>
            <div class="item" v-for="(headerItem,index) in headerList" :key="index">
                <div><span class="title">{{ headerItem.question }}</span></div>
                <div class="content" v-html="headerItem.answer"></div>
                <div v-if="index === 0">
                    <table>
                        <tr v-for="(item,index) in tableData" :key="index">
                            <td class="img">
                                <svg class="icon" aria-hidden="true">
                                    <use v-if="index === 0" xlink:href="#icon-wendang"></use>
                                    <use v-if="index === 1" xlink:href="#icon-V"></use>
                                    <use v-if="index === 2" xlink:href="#icon-renwuqingdan"></use>
                                    <use v-if="index === 3" xlink:href="#icon-liebiao"></use>
                                    <use v-if="index === 4" xlink:href="#icon-dengpao"></use>
                                </svg>
                            </td>
                            <td class="des"><b>{{ item.title }}</b><br>{{ item.des }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="img-cls">
                <img src="@/assets/img/question.jpg" alt="question" width="165" align="center"/>
            </div>
            <div class="question-area">
                <div class="question_content" v-for="(serialItem,serialIndex) in qaSerialList" :key="serialIndex">
                    <div class="question_title">{{ serialItem.title}}</div>
                    <div class="all_question_anser" v-for="(qaItem,qaIndex) in serialItem.qaList" :key="qaIndex">
                        <div class="question"><i class="el-icon-question"/><span v-html="qaItem.question"/></div>
                        <div class="answer" v-if="serialIndex == 0 && qaIndex == 0 "><i
                                class="el-icon-info answer-icon"/>
                            <span v-if="$i18n.locale=='zh'">KCC是网页版平台。点击<span class="click-cls" @click="login">这里</span>进入KCC登录界面，使用您已经注册的工作邮箱，密码和发至您邮箱的验证码即可快速登录KCC。</span>
                            <span v-else>KCC is web-based solution. Click <span class="click-cls"
                                                                                @click="login">here</span> to access your KCC portal and login with your registered working eMail address, password and verification code, which will be sent to your registered email box.</span>
                        </div>
                        <div class="answer" v-else><i class="el-icon-info answer-icon"/><span v-html="qaItem.answer"/>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import windowConfig from '@/utils/windowConfig'
  const href = windowConfig.helpURL.clientFaq
  export default {
    name: "faq",
    data() {
      return {
        headerList: [
          {
            question: this.$t('FAQ_KCC_Q1'),
            answer: this.$t('FAQ_KCC_A1', {href: href})
          }
        ],
        tableData: [
          {
            title: this.$t('FAQ_TABLE_TITLE1'),
            des: this.$t('FAQ_TABLE_DES1')
          },
          {
            title: this.$t('FAQ_TABLE_TITLE2'),
            des: this.$t('FAQ_TABLE_DES2')
          },
          {
            title: this.$t('FAQ_TABLE_TITLE3'),
            des: this.$t('FAQ_TABLE_DES3')
          },
          {
            title: this.$t('FAQ_TABLE_TITLE4'),
            des: this.$t('FAQ_TABLE_DES4')
          },
          {
            title: this.$t('FAQ_TABLE_TITLE5'),
            des: this.$t('FAQ_TABLE_DES5')
          },

        ],
        qaSerialList: [
          {
            title: this.$t('FAQ_SERIAL_TITLE1'),
            qaList: [
              {
                question: this.$t('FAQ_SERIAL1_Q1'),
                answer: this.$t('FAQ_SERIAL1_A1', {href: href})
              },
              {
                question: this.$t('FAQ_SERIAL1_Q2'),
                answer: this.$t('FAQ_SERIAL1_A2')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q3'),
                answer: this.$t('FAQ_SERIAL1_A3')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q4'),
                answer: this.$t('FAQ_SERIAL1_A4')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q5'),
                answer: this.$t('FAQ_SERIAL1_A5')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q6'),
                answer: this.$t('FAQ_SERIAL1_A6')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q7'),
                answer: this.$t('FAQ_SERIAL1_A7')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q8'),
                answer: this.$t('FAQ_SERIAL1_A8')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q9'),
                answer: this.$t('FAQ_SERIAL1_A9')
              },
              {
                question: this.$t('FAQ_SERIAL1_Q10'),
                answer: this.$t('FAQ_SERIAL1_A10')
              }

            ]
          },
          {
            title: this.$t('FAQ_SERIAL_TITLE2'),
            qaList: [
              {
                question: this.$t('FAQ_SERIAL2_Q1'),
                answer: this.$t('FAQ_SERIAL2_A1')
              },
              {
                question: this.$t('FAQ_SERIAL2_Q2'),
                answer: this.$t('FAQ_SERIAL2_A2')
              },
              {
                question: this.$t('FAQ_SERIAL2_Q3'),
                answer: this.$t('FAQ_SERIAL2_A3')
              },
              {
                question: this.$t('FAQ_SERIAL2_Q4'),
                answer: this.$t('FAQ_SERIAL2_A4')
              },
              {
                question: this.$t('FAQ_SERIAL2_Q5'),
                answer: this.$t('FAQ_SERIAL2_A5')
              },
              {
                question: this.$t('FAQ_SERIAL2_Q6'),
                answer: this.$t('FAQ_SERIAL2_A6')
              }
            ]
          },
          {
            title: this.$t('FAQ_SERIAL_TITLE3'),
            qaList: [
              {
                question: this.$t('FAQ_SERIAL3_Q1'),
                answer: this.$t('FAQ_SERIAL3_A1')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q2'),
                answer: this.$t('FAQ_SERIAL3_A2')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q3'),
                answer: this.$t('FAQ_SERIAL3_A3')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q4'),
                answer: this.$t('FAQ_SERIAL3_A4')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q5'),
                answer: this.$t('FAQ_SERIAL3_A5')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q6'),
                answer: this.$t('FAQ_SERIAL3_A6')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q7'),
                answer: this.$t('FAQ_SERIAL3_A7')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q8'),
                answer: this.$t('FAQ_SERIAL3_A8')
              },
              {
                question: this.$t('FAQ_SERIAL3_Q9'),
                answer: this.$t('FAQ_SERIAL3_A9')
              }
            ]
          }
        ]
      }
    },
    methods: {
      login() {
        sessionStorage.removeItem('JSESSIONID')
        localStorage.removeItem('JSESSIONID')
        this.$store.commit('common/setUser', {})
        this.$store.commit('common/setSite', {})
        this.$store.commit('common/setEntity', {})
        this.$router.push('/login')
      }
    }
  }
</script>

<style scoped>
.header{
    text-align: center;
    margin-bottom: 10px;
}
.title{
    color: #eeeeee;
    background-color: rgb(65, 138, 179);
    border-radius: 5px;
    padding: 5px 10px;
}
.all-content{
    padding: 0 70px;
    letter-spacing: 1px;
}
.img-cls{
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
}
.item .title{
    font-size: 20px;
    font-weight: bold;
    height: 28px;
    line-height: 28px;
}
.item .content{
    font-size: 18px;
    height: 26px;
    line-height: 26px;
    margin: 5px 0;
}
.item{
    margin-bottom: 15px;
}
a{
    text-decoration: underline;
    color: rgb(65, 138, 179);
    font-weight: bolder;
}
table tr td {
    border:1PX solid rgb(242, 185, 168);
}
table {
    text-align: center;
    border-collapse: collapse;
    padding:2px;
}
.img{
    width: 300px;
}
.icon{
    font-size: 55px;
    margin: 5px 0;
}
.des{
    width: 900px;
    text-align: left;
    padding-left: 10px;
}
.question_content{
    margin-bottom: 15px;
}
.question_title{
    font-size: 20px;
    font-weight: bolder;
    color: rgb(223, 83, 39);
}
.all_question_anser{
    margin-bottom: 10px;
}
.question, .answer-icon{
    color: rgb(65, 138, 179);
    font-size: 18px;
    font-weight: bold;
}
.answer{
    font-size: 18px;
}
.click-cls{
    text-decoration: underline;
    color: rgb(65, 138, 179);
    font-weight: bolder;
    cursor: pointer;
}
</style>